// Presentation only: keep LoyaltyLion's rows, order and activity-detail handlers intact.
const template = document.querySelector('#sigma-history-pagination-template');
const root = document.querySelector('[data-loyalty-loading-content]');
const mobile = matchMedia('(max-width: 639px)');
const compact = matchMedia('(max-width: 1023px), (max-height: 700px)');
const pageSize = () => mobile.matches ? 3 : compact.matches ? 6 : 10;

if (template && root) {
  const controllers = new Map();
  let scheduled = false;

  function mount(section, table) {
    const nav = template.content.firstElementChild.cloneNode(true);
    nav.hidden = true;
    const range = nav.querySelector('[data-history-range]');
    const pages = nav.querySelector('[data-history-pages]');
    const previous = nav.querySelector('[data-history-previous]');
    const next = nav.querySelector('[data-history-next]');
    const tableId = table.id || 'sigma-points-activity-table';
    table.id = tableId;
    previous.setAttribute('aria-controls', tableId);
    next.setAttribute('aria-controls', tableId);
    table.after(nav);
    let rows = [];
    let size = pageSize();
    let page = 0;
    let anchorRow = null;

    function render() {
      const count = rows.length;
      const pageCount = Math.ceil(count / size);
      page = Math.max(0, Math.min(page, pageCount - 1));
      const start = page * size;
      rows.forEach((row, index) => {
        row.toggleAttribute('data-sigma-history-hidden', index < start || index >= start + size);
      });
      nav.hidden = pageCount <= 1;
      const end = Math.min(start + size, count);
      range.textContent = count ? `${end === start + 1 ? `Activity ${end}` : `Activities ${start + 1}–${end}`} of ${count}` : '';
      previous.disabled = page === 0;
      next.disabled = page >= pageCount - 1;
      const visible = new Set();
      if (mobile.matches) {
        const first = Math.max(0, Math.min(page - 1, pageCount - 3));
        for (let index = first; index < Math.min(pageCount, first + 3); index++) visible.add(index);
      } else if (pageCount <= 7) {
        for (let index = 0; index < pageCount; index++) visible.add(index);
      } else {
        [0, pageCount - 1, page - 1, page, page + 1].forEach(index => {
          if (index >= 0 && index < pageCount) visible.add(index);
        });
      }
      const fragment = document.createDocumentFragment();
      let last = -1;
      [...visible].sort((a, b) => a - b).forEach(index => {
        if (last >= 0 && index > last + 1) {
          const gap = document.createElement('span');
          gap.className = 'sigma-history-pagination__ellipsis';
          gap.textContent = '…';
          gap.setAttribute('aria-hidden', 'true');
          fragment.append(gap);
        }
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'sigma-history-pagination__page';
        button.dataset.historyPage = String(index);
        button.textContent = String(index + 1);
        button.setAttribute('aria-label', `Page ${index + 1}${index === page ? ', current page' : ''}`);
        button.setAttribute('aria-controls', tableId);
        if (index === page) button.setAttribute('aria-current', 'page');
        fragment.append(button);
        last = index;
      });
      pages.replaceChildren(fragment);
    }

    nav.addEventListener('click', event => {
      const button = event.target.closest('button');
      if (!button || button.disabled) return;
      const target = button === previous ? page - 1 : button === next ? page + 1 : Number(button.dataset.historyPage);
      if (!Number.isInteger(target) || target === page) return;
      page = target;
      anchorRow = rows[page * size];
      render();
      const focusTarget = button.isConnected && !button.disabled ? button : pages.querySelector('[aria-current]');
      focusTarget?.focus({ preventScroll: true });
      const heading = section.querySelector('.lion-integrated-page-section__heading-text');
      const top = heading?.getBoundingClientRect().top;
      const headerBottom = document.querySelector('.site-header')?.getBoundingClientRect().bottom || 0;
      if (heading && (top < headerBottom || top > innerHeight)) heading.scrollIntoView({ block: 'start' });
    });

    return {
      update() {
        const nextRows = [...table.querySelectorAll('tbody > tr')];
        const nextSize = pageSize();
        const sameRows = rows.length === nextRows.length && rows.every((row, index) => row === nextRows[index]);
        if (sameRows && size === nextSize && nav.isConnected) return;
        const focusedRow = document.activeElement?.closest('tr');
        const anchor = rows.includes(focusedRow) ? focusedRow : anchorRow || rows[page * size];
        const anchorIndex = nextRows.indexOf(anchor);
        const restoreFocus = nav.contains(document.activeElement);
        page = anchorIndex >= 0 ? Math.floor(anchorIndex / nextSize) : 0;
        rows = nextRows;
        anchorRow = rows[anchorIndex >= 0 ? anchorIndex : 0];
        size = nextSize;
        if (!nav.isConnected) table.after(nav);
        render();
        if (restoreFocus) {
          const heading = section.querySelector('.lion-integrated-page-section__heading-text');
          if (nav.hidden && heading) {
            heading.setAttribute('tabindex', '-1');
            heading.focus({ preventScroll: true });
          } else {
            pages.querySelector('[aria-current]')?.focus({ preventScroll: true });
          }
        }
      },
      remove() {
        rows.forEach(row => row.removeAttribute('data-sigma-history-hidden'));
        nav.remove();
      },
    };
  }

  function update() {
    scheduled = false;
    for (const [table, controller] of controllers) {
      if (!root.contains(table)) {
        controller.remove();
        controllers.delete(table);
      }
    }
    root.querySelectorAll('.lion-account-history .lion-history-table').forEach(table => {
      if (!controllers.has(table)) controllers.set(table, mount(table.closest('.lion-account-history'), table));
      controllers.get(table).update();
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }
  new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
  mobile.addEventListener('change', schedule);
  compact.addEventListener('change', schedule);
  update();
}
